import { Post } from './Post';
import { Rect } from './Rect';
import { Observable } from 'rxjs/Observable';
import { EmptyRect } from './EmptyRect';
declare const THREE: any;

export class SingleCornerPost extends Post {

  loader = new THREE.ImageLoader();
  static readonly Name = 'SingleCornerPost';

  private picture = new THREE.ImageLoader().load('../../../../../assets/images/scene-plan/sc.png');

  public type: string = "SC";
  public labelPos: string = "Center";
  public modifiedAtStep3: boolean = false;


  private static rotationTransform = new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90));
  // getTexture(type): Observable<any> {
  //   return new THREE.TextureLoader().load('assets/images/scene-plan/' + type.toLowerCase() + '.png');
  // }

  constructor(type, picture?) {
    super();
    this.type = type.postType;
    this.labelPos = type.labelPosition;
    if (picture) {
      this.picture = picture;
    }
    this.add(new EmptyRect(10));

    const geometry = new THREE.PlaneBufferGeometry(1, 1).applyMatrix(SingleCornerPost.rotationTransform);
    const material = new THREE.MeshBasicMaterial({ side: THREE.DoubleSide, transparent: true });

    let mesh = new THREE.Mesh(geometry, material);


    let canvas = document.createElement('canvas');

    let ctx = canvas.getContext('2d');

    mesh.scale.set(10 / this.picture.height * this.picture.width, 1, 8);
    canvas.width = 10 / this.picture.height * this.picture.width * 10;
    canvas.height = 8 * 10;


    // let fontSize = 100;
    // const text = this.type;
    // let font = "LatoWebLight";
    // ctx.font = "extra-condensed bolder " + fontSize + "px " + font;
    // ctx.textAlign = 'center';
    // ctx.fillText(text, canvas.width / 2, canvas.height);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(this.picture, 0, -canvas.height / 10, canvas.width, canvas.height * 1.2);
    // ctx.strokeRect(0, 0, canvas.width, canvas.height);

    if (!mesh.material.map) {
      mesh.material.map = new THREE.Texture(canvas);
    }
    mesh.material.map.image = canvas;

    mesh.material.map.needsUpdate = true;
    mesh.material.needsUpdate = true;

    mesh.name = "text";

    this.add(mesh);
    this.name = SingleCornerPost.Name;
  }

  duplicate() {

    const result = new SingleCornerPost({ postType: this.type, labelPosition: this.labelPos }, this.picture);
    result.modifiedAtStep3 = true;
    result.update();
    result.setLabelPos();
    return result;
  }

  setLabelPos() {
    let vect = [
      this.worldToLocal(new THREE.Vector3(12, 0, 0)),
      this.worldToLocal(new THREE.Vector3(0, 0, 12)),
      this.worldToLocal(new THREE.Vector3(-12, 0, 0)),
      this.worldToLocal(new THREE.Vector3(0, 0, -12))
    ];
    let mesh;
    this.children.filter(ch => ch.name === "text").forEach(ch => {
      mesh = ch;
    });
    for (let i = 0; i < 4; i++) {
      let x = vect[i].x * Math.cos(mesh.rotation.y) + vect[i].z * Math.sin(mesh.rotation.y);
      let z = vect[i].z * Math.cos(mesh.rotation.y) - vect[i].x * Math.sin(mesh.rotation.y);
      vect[i] = new THREE.Vector3(x, 0, z);
    }
    // let pos = mesh.getWorldPosition();
    // mesh.applyMatrix( this.matrixWorld );

    if (mesh) {
      switch (this.labelPos) {
        case "Above":
          mesh.position.add(vect[3]);
          break;
        case "Left Side":
          mesh.position.add(vect[2]);
          break;
        case "Right Side":
          mesh.position.add(vect[0]);
          break;
        case "Below":
          mesh.position.add(vect[1]);
          break;
        case "Center":
          break;
      }
    }
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    let rot = {
      x: this.rotation.x,
      y: this.rotation.y,
      z: this.rotation.z
    }
    return {
      type: "Post",
      position: pos,
      rotation: rot,
      scaleCor: this.scaleCor,
      typeP: { postType: this.type, labelPosition: this.labelPos },
      imageSrc: this.picture ? this.picture.src : undefined
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/SingleCornerPost.ts